<template>
  <div class="form-group">
    <label :for="id">
      <span class="af-icons af-icons-lock"></span>
      {{ lang.get('entries.form.season.label') }}
    </label>
    <input
      :id="id"
      type="text"
      class="form-control"
      :value="season.name"
      disabled
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  inject: ['lang'],
  props: {
    id: {
      type: String,
      default: 'seasonId'
    }
  },
  computed: {
    ...mapState('entryForm', ['season'])
  }
};
</script>
